import Model from '@/models/Model'
import { EventBus } from '@/app'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'shippings',
            name: 'shipping',
            class: 'Modules\\Ecommerce\\Entities\\Shipping',
            forms: {}
        }
    },

    methods: {
        setTracking(resource, tracking) {
            return axios({
                method: 'post',
                url: route('api.shippings.set.tracking', resource),
                data: {tracking: tracking}
            })
            .then(response => {
                if(response.data.success) {
                    this.$alert('Actualización exitosa', 'Listo!', 'success')

                    EventBus.$emit('root', 'shippings.tracked', response.data.data)

                    return response.data.data
                } else {
                    this.$alert(response.data,message, 'Error!', 'error')

                    return Promise.reject(response.data,message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')

                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
        }
    },

    created() {
        this.$Util.formattedClassName['Modules\\Ecommerce\\Entities\\Shipping'] = 'Envío'
        this.$Util.tableNameByClassName['Modules\\Ecommerce\\Entities\\Shipping'] = 'shippings'
        this.$Util.classNameByTableName['shippings'] = 'Modules\\Ecommerce\\Entities\\Shipping'
    }
}